import axios from "axios";

const Auth = {
    register: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/register/`, formData);
    },
    fetchPlan: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/plan/selection`, formData);
    },
    verify: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/check/token/`, formData);
    },
    loginOtpVerify: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/login/otp/verify`, formData);
    },
    loginSendOtp: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/login/`, formData);
    },
    checkEmail: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/password/email`, formData);
    },
    resetPassword: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/password/reset`, formData);
    },
    registerSendOtp: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/register/otp/send`, formData);
    },
    registerOtpVerify: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/register/otp/verify`, formData);
    },
    appSendOtp: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/application/otp/send`, formData);
    },
    appOtpVerify: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/application/verify`, formData);
    },
    logout: async (formData) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/logout`, formData);
    }
}

export default Auth;